import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Rota',
  path: '/merenda/merrota',
  name: 'merrota',
  component: () => import('@/views/merenda/merrota/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.ROTANOVO_MENU_1000600799],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Rota',
  path: '/merenda/merrota/cadastro/:id?',
  parent: 'merrota',
  name: 'merrota_create',
  component: () => import('@/views/merenda/merrota/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.ROTANOVO_MENU_1000600799],
  },
  goesToMenu: true,
 },
]
